import React, { forwardRef } from "react";
import { Row, Col, Typography } from "antd";
import { DatePickerItem } from "../../../components/forms/FormItems";
import SwitchItem from "../../../components/forms/SwitchItem";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import { SettingsDataSelect } from "../../../components/forms/AutoCompleteFormItem";
import Surface from "../../../components/layouts/Surface";
import FormHeader from "../../../components/forms/FormHeader";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import moment from "moment";
const { Text } = Typography;

const Specifications = forwardRef((props, ref) => {
  const { activePatient, smallSpace } = props;
  const changedValues = useSelector(
    (state) => state.patientDetails.changedItems.values
  );

  const hasEmergencyDetails =
    changedValues["emergency.has_emergency_details"] === true ||
    (changedValues["emergency.has_emergency_details"] === undefined &&
      activePatient?.emergency?.has_emergency_details === true);
  return (
    <div style={{ display: "flex", flexDirection: "column" }} ref={ref}>
      <Surface smallSpace={smallSpace}>
        <FormHeader
          title={<FormattedMessage id="app.patients.specifications" />}
        />
        <Row>
          <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <SwitchItem name="holocast_survivor" category="patient" />
              </div>
              <div style={{ flex: 1 }}>
                <SwitchItem name="childless" category="patient" />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <SwitchItem name="live_alone" category="patient" />
              </div>
              <div style={{ flex: 1 }}>
                <SwitchItem name="live_in_institution" category="patient" />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <SwitchItem name="use_diapers" category="patient" />
              </div>
              <div style={{ flex: 1 }}>
                <SwitchItem name="has_panic_button" category="patient" />
              </div>
            </ResponsiveItemsWrapper>
          </Col>

          <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <SwitchItem name="shelter_in_building" category="patient" />
              </div>
              <div style={{ flex: 1 }}>
                <SwitchItem name="has_shelter_area" category="patient" />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <SwitchItem
                  name="address_instructions.has_elevator"
                  category="patient"
                />
              </div>
              <div style={{ flex: 1 }}>
                <SwitchItem name="laundary" category="patient" />
              </div>
            </ResponsiveItemsWrapper>
          </Col>
        </Row>
      </Surface>

      <Surface smallSpace={smallSpace}>
        <FormHeader
          title={<FormattedMessage id="app.patients.emergencyDetails" />}
        />
        <Row>
          <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <SwitchItem
                  name="emergency.has_emergency_details"
                  category="patient"
                />
              </div>
              <div style={{ flex: 1 }}>
                {activePatient?.emergency?.last_updated_by_file && (
                  <Text>
                    {moment(
                      activePatient?.emergency?.last_updated_by_file
                    ).format("L")}
                  </Text>
                )}
              </div>
            </ResponsiveItemsWrapper>
          </Col>
        </Row>
        {hasEmergencyDetails && (
          <Row gutter={16}>
            <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
              <ResponsiveItemsWrapper>
                <div style={{ flex: 1 }}>
                  <SwitchItem
                    name="emergency.staris_to_street"
                    category="patient"
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <SwitchItem
                    name="emergency.has_chair_wheel"
                    category="patient"
                  />
                </div>
              </ResponsiveItemsWrapper>

              <ResponsiveItemsWrapper>
                <div style={{ flex: 1 }}>
                  <SwitchItem
                    name="emergency.has_dialysis_machine"
                    category="patient"
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <SettingsDataSelect
                    name="emergency.way_of_communication_id"
                    category="patient"
                    settingsdataName={
                      "system_tables/emergency_communication_ways"
                    }
                  />
                </div>
              </ResponsiveItemsWrapper>
            </Col>

            <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
              <ResponsiveItemsWrapper>
                <div style={{ flex: 1 }}>
                  <SwitchItem
                    name="emergency.bound_to_bed"
                    category="patient"
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <SwitchItem
                    name="emergency.has_oxigen_generator"
                    category="patient"
                  />
                </div>
              </ResponsiveItemsWrapper>

              <ResponsiveItemsWrapper>
                <div style={{ flex: 1 }}>
                  <DatePickerItem
                    name="emergency.gudance_date"
                    category="patient"
                  />
                </div>
                <div style={{ flex: 1 }}></div>
              </ResponsiveItemsWrapper>
            </Col>
          </Row>
        )}
      </Surface>
    </div>
  );
});

export default Specifications;
